"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTokenExpiry = exports.isTokenExpired = void 0;
function isTokenExpired(token) {
    if (typeof token !== "string")
        return false;
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(atob(base64)
        .split("")
        .map(function (c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
    })
        .join(""));
    const { exp } = JSON.parse(jsonPayload);
    const expired = Date.now() >= exp * 1000;
    return expired;
}
exports.isTokenExpired = isTokenExpired;
function getTokenExpiry(token) {
    if (typeof token !== "string")
        return -1;
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(atob(base64)
        .split("")
        .map(function (c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
    })
        .join(""));
    const { exp } = JSON.parse(jsonPayload);
    return exp * 1000 - Date.now();
}
exports.getTokenExpiry = getTokenExpiry;
